export const ApplyWatermarkModal: string = 'ApplyWatermarkModal';
